import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { footerSteps } from '../data/content';
export function Footer() {
  return <footer className="bg-blue-950 px-4 pb-20 pt-12 md:pb-12" data-id="element-85" data-mp="3ggk72reij5xy">
      <div className="mx-auto max-w-4xl text-center" data-id="element-86" data-mp="32onjn0nshk7w">
        <p className="text-2xl font-black uppercase tracking-tight text-white" data-id="element-87" data-mp="32m1bayt2r0om">
          🏠 Clear the Clutter™
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-semibold leading-relaxed text-slate-300" data-id="element-88" data-mp="3ufa6idot1hph">
          A practical home decluttering decision system for clothing, household items,
          electronics, books, papers, hobbies, sentimental belongings, selling, donating, and
          preventing new clutter.
        </p>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm font-bold text-amber-400" data-id="element-89" data-mp="3qcdu54puyhtz">
          {footerSteps.map(step => <li key={step} data-id="element-90" data-mp="2a1jkhcbdo041">{step}</li>)}
        </ul>
        <p className="mt-5 text-sm font-semibold text-slate-300" data-id="element-91" data-mp="2ez1nyn6mln4n">Bright Digital Hub</p>
        <div className="mt-5 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-200 sm:flex-row sm:gap-6" data-id="element-92" data-mp="3lalg1f31y5ty">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-amber-400" href="mailto:compradigitalyaa@gmail.com" data-id="element-93" data-mp="3gck196cnssoa">
            <MailIcon className="h-4 w-4" data-id="element-94" data-mp="3qaq17iewnoqi" /> COMPRADIGITALYAA@GMAIL.COM
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-amber-400" href="https://www.instagram.com/bright_digital_hubonline/" target="_blank" rel="noopener noreferrer" data-id="element-95" data-mp="81flfk1o45ye">
            <InstagramIcon className="h-4 w-4" data-id="element-96" data-mp="cv1rgtdbtbl8" /> Bright Digital Hub
          </a>
        </div>
        <div className="mt-7 border-t border-white/15 pt-6" data-id="element-97" data-mp="qujkxm1khd0x">
          <p className="text-base font-black uppercase text-white" data-id="element-98" data-mp="mrwmh2ae4tur">
            One item. One decision. One destination.
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-99" data-mp="tw5wk16p5gk3">
            © Bright Digital Hub 2026 — All rights reserved.
            <br data-id="element-100" data-mp="yuh6sd0wlt2u" />
            Reproduction, resale, sharing, or redistribution without express authorization is
            prohibited.
          </p>
        </div>
      </div>
    </footer>;
}